import React, { memo } from 'react';

import { downloadFile } from '../helpers/firebasedwl';

import LinkButton from '../components/LinkButton';

interface VersionItemProps {
  versionNumber: string,
  date: string,
  reference: string,
}

function VersionItem({
  versionNumber, date, reference,
}: VersionItemProps) {
  return (
    <div className="component-version-item">
      <div>
        { `${versionNumber} / ${date || ''}` }
      </div>
      <div className="dots"></div>
      <div>
        <LinkButton onClick={() => downloadFile(reference)}>
          Descargar
        </LinkButton>
      </div>
    </div>
  );
}

export default memo(VersionItem);

VersionItem.defaultProps = {
  versionNumber: '',
  date: '',
  reference: null,
}
